<template>
  <v-container>
    <v-row>
      <v-col
        v-for="(serie,index) in series"
        :key="serie.id"
        lg="3"
        md="6"
        sm="12"
      >
        <SerieForm
          :color="serie.color"
          :title="`${$t('graphics.series.title')} ${String.fromCharCode(65 + index)}`"
          :serie="serie"
          :graphic="graphic"
          @reRenderSeries="$emit('getSeries')"
          @getSeriesData="getSeriesData"
          @updateOneSeries="updateOneSeries"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SerieForm from '@/components/graphics/SerieForm.vue';
import { defaultColors } from '@/constants/graphics';

export default {
    name: 'Series',
    components: {
        SerieForm,
    },
    props: {
        series: {
            type: Array,
            default: null,
        },
        identicalScale: {
            type: Boolean,
            default: false,
        },
        graphic: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            colors: defaultColors,
        };
    },
    methods: {
        getSeriesData(graphicId) {
            this.$emit('getSeriesData', graphicId);
        },
        updateOneSeries(updatedSeries) {
            this.$emit('updateOneSeries', updatedSeries);
        },
    },
};
</script>
